import { jobTypeAdd, jobTypeUpdate, jobTypeDelete, jobTypeList } from '@/api'
import { apiJobTypeToUi } from '@/api/adapters'
import resource from '@/mock/store'
import { BEACON_DEFAULT_COLOR, sanitizeMarkerColor } from '@/utils/mapIcons'

const PAGE = { page: 1, page_size: 100 }

async function fetchAllJobTypes(params = {}) {
  const first = await jobTypeList({ ...PAGE, ...params })
  const data = first.data || {}
  let list = data.list || []
  const total = data.total || list.length
  if (total > list.length) {
    const pages = Math.ceil(total / PAGE.page_size)
    const tasks = []
    for (let page = 2; page <= pages; page++) {
      tasks.push(jobTypeList({ ...params, page, page_size: PAGE.page_size }))
    }
    const rest = await Promise.all(tasks)
    rest.forEach(r => {
      list = list.concat((r.data && r.data.list) || [])
    })
  }
  return list
}

let jobTypesLoaded = false

export async function loadJobTypes(params = {}) {
  const force = params.force === true
  if (!force && jobTypesLoaded && resource.jobTypes.length) {
    return resource.jobTypes
  }
  const list = await fetchAllJobTypes(params)
  const uiList = list.map(apiJobTypeToUi)
  resource.jobTypes.splice(0, resource.jobTypes.length, ...uiList)
  jobTypesLoaded = true
  return resource.jobTypes
}

export function resetJobTypesCache() {
  jobTypesLoaded = false
}

export async function createJobType(form) {
  const color = sanitizeMarkerColor(form.color) || BEACON_DEFAULT_COLOR
  const res = await jobTypeAdd({ name: form.name.trim(), color })
  await loadJobTypes({ force: true })
  return res.data
}

export async function updateJobType(form) {
  const color = sanitizeMarkerColor(form.color) || BEACON_DEFAULT_COLOR
  const res = await jobTypeUpdate({
    id: form.id,
    name: form.name.trim(),
    color
  })
  await loadJobTypes({ force: true })
  return res.data
}

export async function deleteJobTypes(ids) {
  await jobTypeDelete({ ids })
  await loadJobTypes({ force: true })
}

export function jobTypeNameById(id) {
  const item = resource.jobTypes.find(j => j.id === id)
  return item ? item.name : ''
}

export function jobTypeColorById(id) {
  const item = resource.jobTypes.find(j => Number(j.id) === Number(id))
  return sanitizeMarkerColor(item && item.color) || BEACON_DEFAULT_COLOR
}
